import React from 'react';
import { Document, Page, View, Image } from '@react-pdf/renderer';
import PdfTab from './PdfTab';
import logo from './AssistPoint_Logo.png';
import LashBmsServiceBrand from './LashBmsServiceBrand';

const styles = {
    page: { paddingTop: 35, paddingBottom: 35, paddingHorizontal: 35 }
}

const opdivo = "Opdivo";
const yervoy = "Yervoy";
const comboField = "Medical Medication Combo";

//This is copy pasted from Berkeley. At some point, how do we generalize this?
const LashBmsPdf = props => {
    const { form, tabs } = props;

    const brandText = () => {
        if (form.meta.brandName !== opdivo && form.meta.brandName !== yervoy) return form.meta.brandName;
        if (form.formData[comboField] !== "Yes") return form.meta.brandName;
        return "Opdivo + Yervoy";
    }

    return <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <View>
                    <Image src={logo} size='small' style={{ width: 200 }} />
                </View>

                <LashBmsServiceBrand services={form.meta.assistanceServices} brand={brandText()} />

                {tabs.map(tab =>
                    <PdfTab
                        key={tab.key}
                        name={tab.name}
                        sections={tab.sections}
                        form={form}
                    />
                )}
            </View>
        </Page>
    </Document>
}

export default LashBmsPdf;
